import { createFileRoute } from "@tanstack/react-router"
import { SignupWithToken } from "modules/auth/components/SignupWithToken"
import { z } from "zod"

const InviteSchema = z.object({
  token: z.string().catch(""),
})

export const Route = createFileRoute("/_base/_public/invite")({
  component: SignupWithToken,
  validateSearch: InviteSchema,
})
